<template>

  <div class="container">
    {{messages}}

  </div>

</template>

<script>

  import {ref} from "vue";
  import {useI18n} from "vue-i18n";

  export default {
    name: "ErrorView",

    setup(){
      const messages = ref([]);
      const { t } = useI18n();
      messages.value = t("Error: Página no existe!!")

      return{
        messages
      }

    }


  }

</script>

<style scoped>

</style>
